import axios from '../axios/axios';
import {
  POLICY_ONWER_ANNUITY_DATA_REQUEST,
  POLICY_ONWER_ANNUITY_DATA_SUCCESS,
  POLICY_ONWER_ANNUITY_DATA_FAIL,
} from '../constants/policyOwnerAnnuityConstants';

export const policyOwnerAnnuityAction = () => async (dispatch) => {
  try {
    dispatch({ type: POLICY_ONWER_ANNUITY_DATA_REQUEST });
    const { data } = await axios.post('/rpiq-form-fetch', {
      section: 'f1v1s28',
      form_id: localStorage.getItem('formId'),
    });

    dispatch({
      type: POLICY_ONWER_ANNUITY_DATA_SUCCESS,
      payload: data,
    });
  } catch (error) {
    if (
      error?.response?.status === 401 ||
      error?.response?.detail === 'Not authenticated'
    ) {
      window.location.replace('/');
    }

    dispatch({
      type: POLICY_ONWER_ANNUITY_DATA_FAIL,
      payload: error,
    });
  }
};
